var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('iframe',{attrs:{"src":_vm.src,"allowfullscreen":"true"}},[_vm._v(">")])])}
var staticRenderFns = []

export { render, staticRenderFns }